import { MDBCol, MDBRow, MDBCard } from 'mdbreact';
import React from "react";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { withRouter } from "react-router-dom";
import { withTheme } from '../../themes/theming';
import Activation from './widgets/activation';
import ActiveRetailers from './widgets/activeRetailers';
import Activities from './widgets/activities';
import ActivitiesDue from './widgets/activitiesDue';
import AvgDaysPerToolbox from './widgets/avgDaysPerToolbox';
import BusinessResults from './widgets/businessResults';
import BusinessResultsTopNmsc from './widgets/businessResultsTopNmsc';
import CertificationRate from './widgets/certificationRate';
import OverdueActivities from './widgets/overdueActivities';
import RecentUpdates from './widgets/recentUpdates';
import ReCertificationRate from './widgets/reCertificationRate';
import RolloutResultsTopNmsc from './widgets/rolloutResultsTopNmsc';
import ToolboxImplementation from './widgets/toolboxImplementation';
import OverdueActivitiesForNMSC from './widgets/overdueActivitiesForNMSC'
import ProgressPerNmsc from './widgets/progressPerNmsc';
import AverageScoreChapter from './widgets/averageScoreChapter';
import ScoreTable from './widgets/scoreTable';
import KaizenOverviewTable from './widgets/kaizenOverview'
import Card from './widgets/card';
import * as AppConst from '../../AppConstant';
import PieChart from './widgets/pieChart';
var I18n = require("react-redux-i18n").I18n;

class WidgetContainer extends React.Component {
    /* eslint-disable */
    constructor(props) {
        super(props);
    }
    render() {
        const {userMdl} = this.props;
        const rolesForKaizenOverview = userMdl.roles.includes("KET NMSC Admin") || userMdl.roles.includes("KET NMSC External") || userMdl.roles.includes("KET NMSC Field") || userMdl.roles.includes("KET-TSP Auditor");

        const settings = {
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 7,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 7,
                        slidesToScroll: 3,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 2,
                        initialSlide: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };
        const responsive = {          

            desktop: {
                breakpoint: { max: 3000, min: 1024 },
                items:  this.props.userMdl.activeProgram !== 'TSM_SURVEYS' ? 7 : 5
            },
            tablet: {
                breakpoint: { max: 1024, min: 464 },
                items: 3
            },
            mobile: {
                breakpoint: { max: 464, min: 0 },
                items: 2
            }
        };
        return (
            <div className="dashboardDiv">
                <Carousel
                    swipeable={false}
                    draggable={false}
                    showDots={false}
                    responsive={responsive}
                    infinite={false}
                    keyBoardControl={true}
                    customTransition="all .5"
                    transitionDuration={500}
                    containerClass="carousel-container"
                    itemClass="carousel-item-padding-40-px">
                    {/* <Slider {...settings}> */}
                    <MDBCard className="scrollable-widgets">
                        <Activation
                            nmscFilter={this.props.nmscFilter}
                            brandFilter={this.props.brandFilter}
                            countryFilter={this.props.countryFilter}
                            regionFilter={this.props.regionFilter}
                            userMdl={this.props.userMdl}
                            nmscFlag={this.props.nmscFlag} 
                            dealerOperations={this.props.dealerOperations || null}
                            />
                    </MDBCard>
                    <MDBCard className="scrollable-widgets">
                        <ActiveRetailers
                            nmscFilter={this.props.nmscFilter}
                            brandFilter={this.props.brandFilter}
                            countryFilter={this.props.countryFilter}
                            regionFilter={this.props.regionFilter}
                            userMdl={this.props.userMdl}
                            nmscFlag={this.props.nmscFlag} 
                            dealerOperations={this.props.dealerOperations || null}
                            />
                    </MDBCard>
                   {userMdl?.activeProgram !== AppConst.activeProgramNas && <MDBCard className="scrollable-widgets">
                        <Activities
                            nmscFilter={this.props.nmscFilter}
                            brandFilter={this.props.brandFilter}
                            countryFilter={this.props.countryFilter}
                            regionFilter={this.props.regionFilter}
                            userMdl={this.props.userMdl}
                            nmscFlag={this.props.nmscFlag} 
                            toolboxFilter={this.props.toolboxList} // for NAS only
                            startDate={this.props.startDate}
                            endDate={this.props.endDate}
                            dealerOperations={this.props.dealerOperations || null}
                            />
                    </MDBCard>}

                    {/* NAS Dashboard Tiles - Starts from here*/}
                    {/* Assessment Tile */}
                    {userMdl?.activeProgram === AppConst.activeProgramNas && <MDBCard className="scrollable-widgets">
                        <Card 
                            theme={this.props.theme}
                            title={I18n.t('TopNav.Assessments')}
                            existingProps={this.props}
                            statusP={I18n.t("Table.Status")}
                            status={[
                                { value: "ONGOING", label: I18n.t('dashboardCards.Ongoing') },
                                { value: "PLANNED", label: I18n.t('dashboardCards.Planned') },
                                { value: "COMPLETED", label: I18n.t('dashboardCards.Completed') },
                            ]}
                            name= {AppConst.NAS_DASHBOARD_CARD.ACTIVITIES}
                            header={I18n.t('dashboardHeaders.AssessmentsTile')}
                            />
                    </MDBCard>}

                    {/* Progress Tile */}
                    {userMdl?.activeProgram === AppConst.activeProgramNas && <MDBCard className="scrollable-widgets">
                        <Card 
                            theme={this.props.theme}
                            title={I18n.t('TopNav.Progress')}
                            existingProps={this.props}
                            statusP={I18n.t("Table.Phase")}
                            status={[
                                { value: "ALL", label: I18n.t('dashboardCards.All') },
                                { value: "FIRST_AUDIT_ONGOING", label: I18n.t('dashboardCards.FirstAuditOngoing') },
                                { value: "COMPLETED_FIRST_AUDIT", label: I18n.t('dashboardCards.CompletedFirstAudit') },
                                { value: "KAIZEN_ONGOING", label: I18n.t('dashboardCards.KaizenOngoing') },
                                { value: "RE_AUDIT_ONGOING", label: I18n.t('dashboardCards.ReAuditOngoing') },
                                { value: "COMPLETED_RE_AUDIT", label: I18n.t('dashboardCards.CompletedReAudit') }
                            ]}
                            name={AppConst.NAS_DASHBOARD_CARD.PROGRESS}
                            isPercentage={true}
                            header={I18n.t('dashboardHeaders.ProgressTile')}
                            />
                    </MDBCard>}
      
                    {/* Passing Tile */}
                    {userMdl?.activeProgram === AppConst.activeProgramNas && <MDBCard className="scrollable-widgets">
                        <Card 
                            theme={this.props.theme}
                            title={I18n.t('TopNav.Passing')}
                            existingProps={this.props}
                            status={[
                                { value: "ALL", label: I18n.t('dashboardCards.AllAudit') },
                                { value: "FIRST_AUDIT", label: I18n.t('dashboardCards.FirstAudit') },
                                { value: "RE_AUDIT", label: I18n.t('dashboardCards.ReAudit') }
                            ]}
                            name={AppConst.NAS_DASHBOARD_CARD.PASSING}
                            isPercentage={true}
                            header={I18n.t('dashboardHeaders.PassingTile')}
                            />
                    </MDBCard>}

                    {/* Kaizen Tile */}
                    {userMdl?.activeProgram === AppConst.activeProgramNas && <MDBCard className="scrollable-widgets">
                        <Card 
                            theme={this.props.theme}
                            title={I18n.t('TopNav.Kaizen')}
                            existingProps={this.props}
                            status={[
                                { value: "NOT_STARTED", label: I18n.t('dashboardCards.NotStarted') },
                                { value: "ONGOING", label: I18n.t('dashboardCards.Ongoing') },
                                { value: "OVERDUE", label: I18n.t('dashboardCards.Overdue') }
                            ]}
                            name={AppConst.NAS_DASHBOARD_CARD.KAIZEN}
                            isPercentage={true}
                            header={I18n.t('dashboardHeaders.KaizenTile')}
                            />
                    </MDBCard>}
                    
                    {/* Score Tile */}
                    {userMdl?.activeProgram === AppConst.activeProgramNas && <MDBCard className="scrollable-widgets">
                        <Card 
                            theme={this.props.theme}
                            title={I18n.t('TopNav.Score')}
                            existingProps={this.props}
                            status={[
                                { value: "FIRST_AUDIT", label: I18n.t('dashboardCards.FirstAudit') },
                                { value: "RE_AUDIT", label: I18n.t('dashboardCards.ReAudit') },
                            ]}
                            name={AppConst.NAS_DASHBOARD_CARD.SCORE}
                            isPercentage={true}
                            header={I18n.t('dashboardHeaders.ScoreTile')}
                            />
                    </MDBCard>}

                    {/* Compliant Tile */}
                    {userMdl?.activeProgram === AppConst.activeProgramNas && <MDBCard className="scrollable-widgets">
                        <Card 
                            theme={this.props.theme}
                            title={I18n.t('TopNav.Compliant')}
                            existingProps={this.props}
                            name={AppConst.NAS_DASHBOARD_CARD.COMPLIANT}
                            isPercentage={true}
                            isLexusValue={true} 
                            header={I18n.t('dashboardHeaders.CompliantTile')}
                            />
                    </MDBCard>}
                    {/* NAS Dashboard Tiles - Ends here*/}

                   {userMdl?.activeProgram !== AppConst.activeProgramNas && <MDBCard className="scrollable-widgets">
                        <ActivitiesDue
                            nmscFilter={this.props.nmscFilter}
                            brandFilter={this.props.brandFilter}
                            countryFilter={this.props.countryFilter}
                            regionFilter={this.props.regionFilter}
                            userMdl={this.props.userMdl}
                            nmscFlag={this.props.nmscFlag} 
                            dealerOperations={this.props.dealerOperations || null}
                            />
                    </MDBCard>}
                    {userMdl?.activeProgram !== AppConst.activeProgramNas && <MDBCard className="scrollable-widgets">
                        <OverdueActivities
                            nmscFilter={this.props.nmscFilter}
                            brandFilter={this.props.brandFilter}
                            countryFilter={this.props.countryFilter}
                            regionFilter={this.props.regionFilter}
                            userMdl={this.props.userMdl} 
                            nmscFlag={this.props.nmscFlag} 
                            dealerOperations={this.props.dealerOperations || null}
                            />
                    </MDBCard>}
                   {userMdl?.activeProgram !== AppConst.activeProgramNas && <MDBCard className="scrollable-widgets">
                        <AvgDaysPerToolbox
                            nmscFilter={this.props.nmscFilter}
                            brandFilter={this.props.brandFilter}
                            countryFilter={this.props.countryFilter}
                            regionFilter={this.props.regionFilter}
                            userMdl={this.props.userMdl} 
                            nmscFlag={this.props.nmscFlag} 
                            dealerOperations={this.props.dealerOperations || null}
                            />
                    </MDBCard>}

                 {this.props.userMdl.activeProgram !== 'TSM' && this.props.userMdl.activeProgram !== 'TSM_SURVEYS' && userMdl?.activeProgram !== "NAS" && 
                     <MDBCard className="scrollable-widgets">
                        <CertificationRate 
                            nmscFilter={this.props.nmscFilter}
                            brandFilter={this.props.brandFilter}
                            countryFilter={this.props.countryFilter}
                            regionFilter={this.props.regionFilter}
                            userMdl={this.props.userMdl} 
                            nmscFlag={this.props.nmscFlag}
                            dealerOperations={this.props.dealerOperations || null}
                            />
                    </MDBCard> }
                    {this.props.userMdl.activeProgram !== 'TSM' && this.props.userMdl.activeProgram !== 'TSM_SURVEYS' && userMdl?.activeProgram !== "NAS" && 
                     <MDBCard className="scrollable-widgets"><ReCertificationRate   
                            nmscFilter={this.props.nmscFilter}
                            brandFilter={this.props.brandFilter}
                            countryFilter={this.props.countryFilter}
                            regionFilter={this.props.regionFilter}
                            userMdl={this.props.userMdl} 
                            nmscFlag={this.props.nmscFlag} 
                            dealerOperations={this.props.dealerOperations || null}
                            />
                    </MDBCard> }
                    {/* </Slider> */}
                </Carousel>
               {userMdl?.activeProgram !== AppConst.activeProgramNas && <MDBRow className="mt-3 mb-5 mr-2">
                    <MDBCol lg="4" md="6" className="ket-widget">
                        <RecentUpdates
                            nmscFilter={this.props.nmscFilter}
                            brandFilter={this.props.brandFilter}
                            countryFilter={this.props.countryFilter}
                            regionFilter={this.props.regionFilter}
                            userMdl={this.props.userMdl} 
                            dealerOperations={this.props.dealerOperations || null}
                            />
                    </MDBCol>
                    <MDBCol lg="4" md="6">
                        <MDBRow className="ket-widget mb-2">
                            <BusinessResults
                                nmscFilter={this.props.nmscFilter}
                                brandFilter={this.props.brandFilter}
                                countryFilter={this.props.countryFilter}
                                regionFilter={this.props.regionFilter}
                                userMdl={this.props.userMdl} 
                                dealerOperations={this.props.dealerOperations || null}
                                />
                        </MDBRow>
                        <MDBRow className="ket-widget mb-2"><BusinessResultsTopNmsc /></MDBRow>
                        
                        {this.props.userMdl.activeProgram !== 'TSM_SURVEYS' &&
                        <MDBRow className="ket-widget mb-0" style={{  }}>
                            {!this.props.nmscFlag ?<RolloutResultsTopNmsc 
                                nmscFilter={this.props.nmscFilter}
                                brandFilter={this.props.brandFilter}
                                countryFilter={this.props.countryFilter}
                                regionFilter={this.props.regionFilter}
                                userMdl={this.props.userMdl} 
                                dealerOperations={this.props.dealerOperations || null}
                                />:
                            <OverdueActivitiesForNMSC
                                nmscFilter={this.props.nmscFilter}
                                brandFilter={this.props.brandFilter}
                                countryFilter={this.props.countryFilter}
                                regionFilter={this.props.regionFilter}
                                userMdl={this.props.userMdl}
                                nmscFlag={this.props.nmscFlag}
                                dealerOperations={this.props.dealerOperations || null}
                            />}
                        </MDBRow>
    }
                    </MDBCol>
                    <MDBCol lg="4" md="6" className="ket-widget">
                        <ToolboxImplementation
                            nmscFilter={this.props.nmscFilter}
                            brandFilter={this.props.brandFilter}
                            countryFilter={this.props.countryFilter}
                            regionFilter={this.props.regionFilter}
                            userMdl={this.props.userMdl}
                            nmscFlag={this.props.nmscFlag} 
                            dealerOperations={this.props.dealerOperations || null}
                            />
                    </MDBCol>
                </MDBRow>}

                {userMdl?.activeProgram === AppConst.activeProgramNas && <MDBRow className="mt-3 mb-5 mr-2">
                    <MDBCol lg="4" md="6" className="ket-widget">
                        {rolesForKaizenOverview ? <KaizenOverviewTable existingProps={this.props}  dealerOperations={this.props.dealerOperations || null} /> : < ProgressPerNmsc existingProps={this.props}  dealerOperations={this.props.dealerOperations || null} />}
                    </MDBCol>
                    <MDBCol lg="4" md="6" >
                        <MDBCol className="ket-widget" >
                            <AverageScoreChapter existingProps={this.props}  dealerOperations={this.props.dealerOperations || null}/>
                        </MDBCol>
                    </MDBCol>
                    <MDBCol lg="4" md="6" className="ket-widget">
                        <MDBRow className="ket-widget">
                             <PieChart existingProps={this.props}  dealerOperations={this.props.dealerOperations || null}/>
                        </MDBRow>

                        <MDBRow className="ket-widget">
                            <ScoreTable existingProps={this.props}  dealerOperations={this.props.dealerOperations || null}/>
                        </MDBRow>
                    </MDBCol>
                </MDBRow>}
            </div>
        );
    }
}
export default withRouter((withTheme(WidgetContainer)));